<template>
  <Modal v-model="batchAuditModal" :title="batchAuditTitle" width="600" class-name="batchAuditStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="batchAuditModalChange">
    <Form ref="batchAuditForm" :model="batchAuditForm" :rules="ruleValidate" :label-width="130" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003925')" prop="type" class="radio_styles">
            <RadioGroup v-model="batchAuditForm.auditStatus">
              <Radio :label="2">{{ $t('key1000986') }}</Radio>
              <Radio :label="3">{{ $t('key1001977') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="batchAuditForm.auditStatus === 3">
          <Form-item :label="$t('key1003926')" prop="auditRemarks">
            <Input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 6}"
              v-model.trim="batchAuditForm.auditRemarks">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="batchAuditModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="batchAuditBtn">{{ $t('key1000543') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "batchAuditModal",
  mixins: [Mixin],
  data() {
    return {
      batchAuditModal: false,
      batchAuditTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003204'),
      batchAuditForm: {
        auditStatus: 2,
        auditRemarks: ''
      },
      ruleValidate: {
        auditRemarks: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003924'), trigger: 'blur'}
        ],
      },
      ymsPickupOrderIds: null,
      auditType: 'single'
    };
  },
  methods: {
    // 初始化数据
    initBatchAuditData(type, ymsPickupOrderIds) {
      let obj = {
        all: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003204'),
        single: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002930'),
        again: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003856')
      };
      this.auditType = type;
      this.batchAuditTitle = obj[type];
      this.ymsPickupOrderIds = ymsPickupOrderIds;
      this.batchAuditModal = true;
    },
    // 确认按钮
    batchAuditBtn() {
      let v = this;
      let url = '';
      let query = {
        auditRemarks: v.batchAuditForm.auditRemarks,
        auditStatus: v.batchAuditForm.auditStatus,
        ymsPickupOrderIds: v.ymsPickupOrderIds
      };
      if (v.auditType === 'again') {
        url = api.post_ymsPickupOrder_againSubsidyAudit;
      } else {
        url = api.post_ymsPickupOrder_batchSubsidyAudit;
      }
      v.$refs['batchAuditForm'].validate((valid) => {
        if (valid) {
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247'),}).then(response => {
            if (response.data.code === 0) {
              v.batchAuditModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    batchAuditModalChange(value) {
      if (!value) {
        this.$refs['batchAuditForm'].resetFields();
        this.ymsPickupOrderIds = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>